import { Component } from '@angular/core';

@Component({
  selector: 'app-toggle-playground',
  templateUrl: './toggle-playground.component.html',
  styleUrls: ['./toggle-playground.component.scss'],
})
export class TogglePlaygroundComponent {
  label = 'Etiqueta del toggle';
  checked = false;
  disabled = false;
  color: 'primary' | 'accent' | 'warn' = 'primary';
  labelPosition: 'before' | 'after' = 'after';

  lastEvent = '';

  onChange(v: boolean): void {
    this.lastEvent = `change: ${v} @ ${new Date().toLocaleTimeString()}`;
  }

  readonly colors = ['primary', 'accent', 'warn'] as const;
  readonly positions = ['before', 'after'] as const;
}
